import { Component } from '@angular/core';

@Component({
  selector: 'payee-horizontal-line',
  templateUrl: './payee-horizontal-line.component.html',
  styleUrls: ['./payee-horizontal-line.component.scss'],
})
export class PayeeHorizontalLineComponent {}
